import React, { useEffect, useRef, useState } from 'react';
import { Loader } from 'react-feather';
import ManageTable from '../../../Manage/ManageTable';
import PopupModal from '../../../Manage/PopupModal';
import { Col, Row } from 'reactstrap';
import WishlistDetails from './WishlistDetails/WishlistDetails';


const AllWishlist = () => {
  const [loading, setLoading] = useState(true);
    const [tableData, setTableData] = useState([]);
    const [modal, setModal] = useState(false);
    const handleModal = () => setModal(!modal);

    const sectionRefs = useRef({});

    const [selectedWishlist, setSelectedWishlist] = useState(null);

    const [allWishlistDetails, setAllWishlistDetails] = useState([]);

    const mockData = [
        {
            id:1,
            wishlist_name: "My Birthday Wishlist",
            items: 3,
            action: "Edit/Delete"
        },
        {
            id:2,
            wishlist_name: "Holiday Gift Ideas",
            items: 5,
            action: "Edit/Delete"
        },
        {
            id:3,
            wishlist_name: "wee",
            items: 10,
            action: "Edit/Delete"
        }
    ];

    useEffect(() => {
        // Simulate fetching data
        setTableData(mockData);
        setLoading(false);
        fetchAllWishlistDetails();
    }, []);

    const [openName, setOpenName] =  useState('')
    const [data, setData] =  useState('')

    const clickHandler = (data, name) => {
      setModal(true)    
      console.log('NAME', name, data)
          setOpenName(name)
          setData(data)
    
    }

    const clickWishlist = (wishlist) => {
        setSelectedWishlist(wishlist);
        const sectionRef = sectionRefs.current[wishlist.id];
        if (sectionRef) {
          sectionRef.scrollIntoView({ behavior: 'smooth' });
        }
      };

    const editDelete = (row, name) => {
      // console.log('NAME', row, name)
    }

    const columns = [
        {
            name: "Wishlist Name",
            cell: (row) => <span title={row.wishlist_name} className="ellipsis" style={{cursor:'pointer'}} onClick={() => clickWishlist(row)}>{row.wishlist_name}</span>,
            selector: (row) => row.wishlist_name,
            sortable: true,
        },
        {
            name: "Items",
            cell: (row) => <span title={row.items} className="ellipsis">{row.items}</span>,
            selector: (row) => row.items,
            sortable: true,
        },
        {
            name: "Action",
            cell: (row) => 
            <div style={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-around'}}>
              <span title={'Edit'} style={{color:'#41B8E4',cursor:'pointer'}} onClick={()=> clickHandler(row, 'Edit Wishlist')} className="ellipsis">{'Edit'}</span> 

              <span title={'Delete'} style={{color:'#41B8E4',cursor:'pointer'}} onClick={()=> editDelete(row, 'Delete')} className="ellipsis">{'Delete'}</span>
            </div>,
            selector: (row) => row.action,
            sortable: true,
            center:true,
        },
    ];

    const fetchAllWishlistDetails = () => {
        const allDetails = mockData.map(wishlist => ({
          wishlist_id: wishlist.id,
          wishlist_name: wishlist.wishlist_name,
          details: [
            {
              id: 1,
              productName: 'Headphones',
              dateAdded: '30/04/2024',
              price: '$150.00',
              action: 'View/Add to cart',
              image: ''
            },
            {
              id: 2,
              productName: 'Headphones',
              dateAdded: '30/04/2024',
              price: '$150.00',
              action: 'View/Add to cart',
              image: ''
            },
            {
              id: 3,
              productName: 'Headphones',
              dateAdded: '30/04/2024',
              price: '$150.00',
              action: 'View/Add to cart',
              image: ''
            },
            {
              id: 4,
              productName: 'Headphones',
              dateAdded: '30/04/2024',
              price: '$150.00',
              action: 'View/Add to cart',
              image: ''
            },
          ]
        }));
        setAllWishlistDetails(allDetails);
      };
    


    return (
        <>
            <div>
              <Row>
                <Col lg='10'>
                  {loading ? <Loader /> :
                      <ManageTable
                          name={'All Wishlist'}
                          columns={columns}
                          setTableData={setTableData}
                          tableData={tableData}
                      />
                  }
                </Col>
                <Col lg='2'>
          <button type='submit' className='btn' onClick={() => clickHandler("",'Create New Wishlist')} style={{ backgroundColor: '#41B8E4', color: 'white' }}>{
          'Make New Wishlist'}</button>
                  
                </Col>
              </Row>
                <div>
                  
                  <div>
                  {allWishlistDetails.map(wishlist => (
            <div key={wishlist.wishlist_id} ref={el => sectionRefs.current[wishlist.wishlist_id] = el}>
              <WishlistDetails wishlist={wishlist} />
            </div>
          ))}
                  </div>
                  
                </div>
            </div>

            <PopupModal
                company_id={''}
                open={modal}
                setModal={setModal}
                handleModal={handleModal}
                name={openName}
                tableData={openName == "Edit Wishlist" ? data : ""}
                setTableData={''}
            />
        </>
    );
}


export default AllWishlist